import React, { FC, memo, useMemo } from 'react'
import s from './MapRestCardCover.module.sass'
import Image from 'next/image'
import IconPhoto from '@icons/icon-photo.svg'
import { Text } from '@shared/ui/Typography/Text'
import { useAppSelector } from '@app/model/store'
import { Carousel } from '@shared/ui/Layout/Carousel'
import { IconButton } from '@shared/ui/Actions/IconButton'
import IconArrow from '@icons/icon-arrow-slider.svg'
import { EGG } from '@shared/api/analytics'
import { MediaImg } from '@shared/ui/Media/MediaImg'
import { getPlaceholderImage } from '@shared/lib/helpers/getPlaceholderImage'

const MapRestCardCover: FC = () => {
  const mapStore = useAppSelector((store) => store.features.map)
  const restData = mapStore.selected.data
  const galleriesStatus = mapStore.galleries.status
  const galleryData = mapStore.galleries.data[restData.id]

  const img = restData.images.cover.rest1064x1064 || restData.images.cover.rest1894x1000 || restData.images.main
  const imgAlt = restData.name ? `Фото ресторана от Афиши — ${restData.name}` : `Фото ресторана от Афиши`
  const getImg = useMemo(() => {
    if (!restData.isShowUI.img || !img) return getPlaceholderImage()
    else return img
  }, [img])

  const getArrImages = useMemo(() => {
    const mainImage = getImg
    const anotherImages = galleryData?.length > 1 ? galleryData.map((img) => img.cover_images['400x300']).slice(1) : []
    return [mainImage, ...anotherImages]
  }, [galleryData])

  const handleClickPrev = () => {
    EGG.pages.Map.click_rest_cover_forward()
  }
  const handleClickNext = () => {
    EGG.pages.Map.click_rest_cover_back()
  }

  return galleriesStatus === 'loading' ? (
    <div className={s['image-wrapper']}></div>
  ) : (
    <div className={s['image-wrapper']}>
      {galleryData?.length ? (
        <>
          <Carousel>
            <div className={s.arrows}>
              <Carousel.Arrow direction={'prev'} className={s.arrow}>
                <IconButton sizes={'M'} mode={'white'} icon={IconArrow} onClick={handleClickPrev} />
              </Carousel.Arrow>
              <Carousel.Arrow direction={'next'} className={s.arrow}>
                <IconButton sizes={'M'} mode={'white'} icon={IconArrow} onClick={handleClickNext} />
              </Carousel.Arrow>
            </div>
            <Carousel.Slider spacingMobile={4} spacingDesktop={4} className={s.slider}>
              {getArrImages.map((imgSrc) => (
                <MediaImg
                  image={{
                    Url: imgSrc,
                    Width: 438,
                    Height: 270,
                    Crop: null,
                    Description: imgAlt,
                    Copyright: null,
                    Author: null,
                  }}
                  width={270}
                  height={438}
                  flexible={true}
                  className={s.image}
                />
              ))}
            </Carousel.Slider>
          </Carousel>
          <div className={s['badge-gallery']}>
            <IconPhoto />
            <Text sizes={'S'} className={s['badge-gallery-count']}>
              {galleryData.length}
            </Text>
          </div>
        </>
      ) : (
        // @ts-ignore
        <img src={getImg} alt={imgAlt} width={438} height={270} className={s.image} />
      )}
    </div>
  )
}

export default memo(MapRestCardCover)
